import { render } from "./EdMoment.vue?vue&type=template&id=e07c00ec"
import script from "./EdMoment.vue?vue&type=script&lang=js"
export * from "./EdMoment.vue?vue&type=script&lang=js"

import "./EdMoment.vue?vue&type=style&index=0&id=e07c00ec&lang=css"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__